// TODO: delete with FEATURE_FLAG_STUDIO_V2
import { createActions } from '../utils/actions';

const { actions: studioEditor } = createActions('studioEditor')
  .add('listingSelected')
  .add('resetState')
  .add('setValue');

export default studioEditor;
